import Vue from 'vue';
import interceptorsSetup from '@/services/clients/interceptor';
import App from './App.vue';
import router from './router';
import store from './store';

// Element
import '@/plugins/element';
// eCharts
import '@/plugins/eCharts';
// primeVue
import '@/plugins/primevue';
// BootstrapVue
import '@/plugins/bootstrapvue';
// Sweet alert
import '@/plugins/sweetalert';
// JWT decoder
import '@/plugins/jwtDecoder';

interceptorsSetup();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
